export * from "../CandidateDrawer/constants";

export const CONTRACT_WORK_TAB = "contract_work";
